// extracted by mini-css-extract-plugin
export default {"Text":"InputLabel-module__Text__VXAtn0c","Box":"InputLabel-module__Box__pJ6a2Yy","Box_1":"InputLabel-module__Box_1__PD1OGLe"};